/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { api } from 'services/api';
import { notificationContainer } from 'utils/notificationContainer';
import { PayloadAction } from '@reduxjs/toolkit';
import { set } from 'lodash';
import {
	TSwedBankIntegrationRequestPayload,
	TSwedBankIntegrationResponsePayload,
	TSwedBankUploadStatementFileRequest,
	TSwedBankSearchInvoicesRequestPayload,
	TSwedBankSearchInvoicesResponsePayload,
	TSwedBankMarkAsProcessedRequestPayload,
	TSwedBankMarkAsProcessedRequest,
	TAttachVatReimbursementRequest,
} from './types';
import {
	getSwedBankIntegrationRequest,
	getSwedBankIntegrationSuccess,
	swedBankInitState,
	uploadStatementFileRequest,
	uploadStatementFileSuccess,
	searchInvoiceRequest,
	searchInvoiceSuccess,
	markAsProcessedRequest,
	markAsProcessedSuccess,
	attachVatReimbursementSuccess,
	attachVatReimbursementRequest,
} from './reducer';
import { getVatReimbursementsRequest } from '../vatReimbursement/reducer';
import { TVatReimbursementsData } from '../vatReimbursement/types';

export function* getSwedBankIntegrationRequestWorker(
	action: PayloadAction<TSwedBankIntegrationRequestPayload>,
) {
	const { payload } = action;
	try {
		const response: TSwedBankIntegrationResponsePayload = yield call(
			api.swedBank.getSwedBankIntegration,
			payload,
		);
		yield put(getSwedBankIntegrationSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(swedBankInitState());
	}
}

export function* uploadStatementFileRequestWorker(
	action: PayloadAction<TSwedBankUploadStatementFileRequest>,
) {
	const { payload } = action;
	try {
		yield call(api.swedBank.uploadStatementFile, payload);
		yield put(uploadStatementFileSuccess());
		notificationContainer('Statement file uploaded successfully', 'success');
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error), 'error');
		}
		yield put(swedBankInitState());
	}
}

export function* searchInvoiceRequestWorker(
	action: PayloadAction<TSwedBankSearchInvoicesRequestPayload>,
) {
	const { payload } = action;
	try {
		const response: TSwedBankSearchInvoicesResponsePayload = yield call(
			api.swedBank.searchInvoices,
			payload,
		);
		yield put(searchInvoiceSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(
				String(error?.response?.data?.message ?? error?.response?.data ?? error ?? 'Error'),
				'error',
			);
		}
		// yield put(swedBankInitState());
		yield put(searchInvoiceSuccess([]));
	}
}

export function* markAsProcessedRequestWorker(
	action: PayloadAction<TSwedBankMarkAsProcessedRequest>,
) {
	const { payload } = action;
	try {
		yield call(api.swedBank.markAsProcessed, payload.body);
		yield put(markAsProcessedSuccess());
		if (payload.body.type === 'attached')
			notificationContainer('Connected to paid invoice successfully', 'success');
		else if (payload.body.type === 'paid')
			notificationContainer('Marked as Processed successfully', 'success');
		else if (payload.body.type === 'skipped')
			notificationContainer('Marked as Not an Invoice Payment successfully', 'success');
		// setTimeout(() => {
		// 	window.location.reload();
		// }, 1000);
		yield put(getSwedBankIntegrationRequest(payload.swedBankIntegrationRequest));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(
				String(error?.response?.data?.message ?? error?.response?.data ?? error ?? 'Error'),
				'error',
			);
		}
		// yield put(swedBankInitState());
	}
}

function* attachVatReimbursementSaga(action: PayloadAction<TAttachVatReimbursementRequest>) {
	try {
		yield call(api.swedBank.attachVatReimbursement, action.payload);
		yield put(attachVatReimbursementSuccess());
		notificationContainer('Vat reimbursement attached successfully', 'success');
		yield put(getSwedBankIntegrationRequest(action.payload.swedBankIntegrationRequest));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			notificationContainer(String(error?.response?.data?.message ?? error ?? 'Error!'), 'error');
		}
	}
}

export function* swedBankSaga() {
	yield takeEvery(getSwedBankIntegrationRequest.type, getSwedBankIntegrationRequestWorker);
	yield takeEvery(uploadStatementFileRequest.type, uploadStatementFileRequestWorker);
	yield takeEvery(searchInvoiceRequest.type, searchInvoiceRequestWorker);
	yield takeEvery(markAsProcessedRequest.type, markAsProcessedRequestWorker);
	yield takeEvery(attachVatReimbursementRequest.type, attachVatReimbursementSaga);
}
